module.exports = __webpack_public_path__ + "static/media/ReactInternals1.4c40e742.md";